var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.565 10.7013C37.367 9.91032 36.9638 9.18559 36.3961 8.60031C35.8284 8.01504 35.1163 7.58994 34.3317 7.36797C31.465 6.66797 19.9983 6.66797 19.9983 6.66797C19.9983 6.66797 8.53168 6.66797 5.66502 7.43464C4.88043 7.65661 4.16831 8.0817 3.60059 8.66698C3.03288 9.25226 2.62966 9.97699 2.43168 10.768C1.90704 13.6772 1.65041 16.6285 1.66502 19.5846C1.64631 22.563 1.90296 25.5368 2.43168 28.468C2.64995 29.2344 3.06219 29.9315 3.62859 30.4921C4.19498 31.0527 4.89638 31.4577 5.66502 31.668C8.53168 32.4346 19.9983 32.4346 19.9983 32.4346C19.9983 32.4346 31.465 32.4346 34.3317 31.668C35.1163 31.446 35.8284 31.0209 36.3961 30.4356C36.9638 29.8504 37.367 29.1256 37.565 28.3346C38.0856 25.4473 38.3422 22.5185 38.3317 19.5846C38.3504 16.6062 38.0937 13.6325 37.565 10.7013Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 25.0328L25.8333 19.5828L16.25 14.1328V25.0328Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.7fc18a25e35f83dc18763822e6f9250c.svg";
export { ForwardRef as ReactComponent };